import { useEffect, useState } from "react";

export const SecondNav = ({ from, setActive, active }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (from === "mangers") setData(MangerNav);
    if (from === "support") setData(SupportNav);
  }, [from]);
  return (
    <ul className="second__nav">
      {data.map((item, key) => (
        <li
          key={key}
          className={`menu-btn__item ${
            active === item.active ? "second__nav-active" : ""
          } `}
          onClick={() => setActive(item.active)}
        >
          {" "}
          {item.name}
        </li>
      ))}
    </ul>
  );
};

const MangerNav = [
  {
    name: "الكل",
    active: "all",
  },
  {
    name: "المشرفين موثقون",
    active: "varified-mangers",
  },
  {
    name: "المشرفين المحظورين",
    active: "block-mangers",
  },
];
const SupportNav = [
  {
    name: "الكل",
    active: "all",
  },
  {
    name: "رسائل تم قرائتها",
    active: "varified-mangers",
  },
  {
    name: "رسائل  لم نتم قرائتها",
    active: "block-mangers",
  },
];
